import React, { useEffect } from 'react';
import { FaLink, FaGlobe, FaUsers, FaChartLine, FaStar, FaQrcode, FaFileAlt, FaCog, FaArrowRight, FaExternalLinkAlt } from 'react-icons/fa';
import { Link, Globe, Users, TrendingUp, Star, QrCode, FileText, Settings, ArrowRight, ExternalLink, MessageSquare } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Hero() {

    const navigate = useNavigate();
    useEffect(() => {
        // Add Bootstrap CSS
        const link = document.createElement('link');
        link.href = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css';
        link.rel = 'stylesheet';
        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link);
        };
    }, []);
    const handleBuyPlan = () => {
        navigate('/signup');
    }
    return (
        <div className="hero-wrapper">

            <section className="hero-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 mb-5 mb-lg-0">
                            <div className="highlight-badge" style={{ display: 'block', width: 'fit-content', margin: '0 auto' }}>
                                ✨ All-in-One Platform
                            </div>

                            <h1 className="hero-title">
                                Build Your Digital Presence in Minutes
                            </h1>

                            <p className="hero-subtitle">
                                Create stunning bio pages, shorten links, generate QR codes, and track everything with powerful analytics. All the tools you need in one place.
                            </p>

                            <div className="feature-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)' }}>
                                <div className="feature-card">
                                    <div className="feature-icon">
                                        <Users size={24} />
                                    </div>
                                    <h3 className="feature-title">Bio Pages</h3>
                                </div>
                                <div className="feature-card">
                                    <div className="feature-icon">
                                        <Link size={24} />
                                    </div>
                                    <h3 className="feature-title">Short Links</h3>
                                </div>

                                <div className="feature-card">
                                    <div className="feature-icon">
                                        <QrCode size={24} />
                                    </div>
                                    <h3 className="feature-title">QR Codes</h3>
                                </div>

                                <div className="feature-card">
                                    <div className="feature-icon">
                                        <MessageSquare size={24} />
                                    </div>
                                    <h3 className="feature-title">Chat</h3>
                                </div>
                                {/* <div className="feature-card">
                                    <div className="feature-icon">
                                        <TrendingUp size={24} />
                                    </div>
                                    <h3 className="feature-title">Analytics</h3>
                                </div>
                                <div className="feature-card">
                                    <div className="feature-icon">
                                        <FileText size={24} />
                                    </div>
                                    <h3 className="feature-title">SEO Tools</h3>
                                </div>
                                <div className="feature-card">
                                    <div className="feature-icon">
                                        <Settings size={24} />
                                    </div>
                                    <h3 className="feature-title">Converters</h3>
                                </div> */}
                            </div>

                            <div className="d-flex gap-2 gap-sm-3 flex-nowrap mt-4 w-100">
                                <button className="btn-hero-primary flex-fill justify-content-center px-1 px-sm-4 text-nowrap" onClick={handleBuyPlan}>
                                    Get Started Free <ArrowRight className="d-none d-sm-inline" size={20} />
                                </button>
                                <button className="btn-hero-secondary flex-fill justify-content-center px-1 px-sm-4 text-nowrap">
                                    View Demo <ExternalLink className="d-none d-sm-inline" size={18} />
                                </button>
                            </div>

                            {/* <div className="stats-section">
                                <div className="row">
                                    <div className="col-4">
                                        <div className="stat-item">
                                            <div className="stat-number">10K+</div>
                                            <div className="stat-label">Active Users</div>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="stat-item">
                                            <div className="stat-number">50K+</div>
                                            <div className="stat-label">Links Created</div>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="stat-item">
                                            <div className="stat-number">99.9%</div>
                                            <div className="stat-label">Uptime</div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>

                        <div className="col-lg-6">
                            <div className="phone-showcase">
                                <div className="phone-mockup phone-mockup-1">
                                    <div className="phone-screen screen-gradient-2">
                                        <div className="phone-notch"></div>
                                        <div className="screen-content">
                                            <div className="screen-header">
                                                <div className="screen-avatar">🔗</div>
                                                <div className="screen-title">Short Links</div>
                                                <div className="screen-subtitle">Powerful link management</div>
                                            </div>
                                            <div className="screen-links">
                                                <div className="screen-link">✂️ Link Shortening</div>
                                                <div className="screen-link">📈 Click Tracking</div>
                                                <div className="screen-link">🌍 Geo Tracking</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="phone-mockup phone-mockup-2">
                                    <div className="phone-screen screen-gradient-1">
                                        <div className="phone-notch"></div>
                                        <div className="screen-content">
                                            <div className="screen-header">
                                                <div className="screen-avatar">🌐</div>
                                                <div className="screen-title">Bio Page</div>
                                                <div className="screen-subtitle">Your digital identity</div>
                                            </div>
                                            <div className="screen-links">
                                                <div className="screen-link">👤 Custom Profile</div>
                                                <div className="screen-link">👁️ Hide/Unhide Content</div>
                                                <div className="screen-link">🎨 Themes & Styles</div>
                                                <div className="screen-link">📊 Visitor Analytics</div>
                                            </div>
                                            <div className="social-icons">
                                                <div className="social-icon">📷</div>
                                                <div className="social-icon">🐦</div>
                                                <div className="social-icon">💼</div>
                                                <div className="social-icon">📧</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="phone-mockup phone-mockup-3">
                                    <div className="phone-screen screen-gradient-3">
                                        <div className="phone-notch"></div>
                                        <div className="screen-content">
                                            <div className="screen-header">
                                                <div className="screen-avatar">💬</div>
                                                <div className="screen-title">Chat List</div>
                                                <div className="screen-subtitle">Connect with followers</div>
                                            </div>
                                            <div className="screen-links">
                                                <div className="screen-link">💬 One-to-One Chat</div>
                                                <div className="screen-link">✅ Message Status</div>
                                                <div className="screen-link">🚫 Block/Report User</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}
